import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from '../../shared/components';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-with-navigation',
  standalone: true,
  imports: [RouterOutlet, NavigationComponent],
  template: `
    <div class="dpqa-with-navigation">
      <dpqa-navigation />
    </div>
    <div class="dpqa-with-navigation__content">
      <router-outlet />
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
      }
    `,
    `
      .dpqa-with-navigation__content {
        flex: 1;
        overflow: auto;
      }
    `,
  ],
})
export class WithNavigationComponent {
  // TODO: add the class for the route-name to the host element
}
